import { ChangeEvent, useCallback, useMemo, useState } from 'react'
import { Column } from '../typings'

export const useFilteredColumns = (columns: Column[]) => {
  const [filter, setFilter] = useState('')

  const onChangeFilter = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => setFilter(event.target.value),
    [],
  )

  const onClearFilter = useCallback(() => setFilter(''), [])

  const filteredColumns = useMemo(
    () =>
      columns.filter((c) =>
        c.label.toLowerCase().includes(filter?.toLowerCase()),
      ),
    [columns, filter],
  )

  return {
    filter,
    onChangeFilter,
    onClearFilter,
    filteredColumns,
  }
}
